import Vue from 'vue';
import axios from 'axios';

import jquery from 'jquery';
window.$ = window.jQuery = jquery;


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios;

window.axios.defaults.headers.common = {
    'X-XSRF-TOKEN': window.MAT.csrfToken,
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json'
};

/**
 * Intercept the incoming responses.
 *
 * Handle any unexpected HTTP errors and pop up modals, etc.
 */
axios.interceptors.response.use(function (response) {
    return response;
}, async function (error) {
    switch (error.response.status) {
        case 401:
            if (error.response.config.url !== '/api/auth/logout') {
                await axios.post('/api/auth/logout');
            }
            window.location.href = '/login';
            break;
    }

    return Promise.reject(error);
});

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */
if (window.Vue === undefined) {
    window.Vue = Vue;

    window.Bus = new Vue();
}


// require datepicker jQuery/Bootstrap library
import moment from 'moment';
window.moment = moment;
window.moment.locale('en');

/**
 * Load up any global utility scripts
 */
import Notifications from 'etap/utilities/notifications';
import Lang from 'etap/utilities/translate';
import ObjectUtils from 'etap/classes/object_utils';
window.notify = new Notifications();


window.Lang = new Lang();
window.Lang.setMessages(window.MAT.translations);
window.ObjectUtils = new ObjectUtils();

/**
 * import global mixins
 */
import ModelMap from 'etap/mixins/model_map';
import LanguageTranslation from 'etap/mixins/language_translation';
Vue.mixin(ModelMap);
Vue.mixin(LanguageTranslation);


/**
 * import css
 */
import 'font-awesome/css/font-awesome.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'dropzone/dist/dropzone.css';
import 'toastr/build/toastr.css';
import 'animate.css/animate.css';
import 'matInstallCss/style.css';
import 'jquery-ui/dist/themes/base/jquery-ui.min.css';
import 'matInstallCss/jquery-ui.structure.css';
import 'matInstallCss/jquery-ui.theme.css';
import 'matInstallCss/offline-theme-chrome-indicator.css';
import 'matInstallCss/offline-theme-chrome.css';
import 'appCss/app.scss';

export default {

}
